import commonZhHK from './common_zh-HK'

const supplierZhHK = {
  supplier: {
    ...commonZhHK,
  }
}

export default supplierZhHK